import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';

@Component({
    selector: 'finder-filter-button',
    templateUrl: './filter-button.component.html',
    styleUrls: ['./filter-button.component.scss'],
    standalone: true,
    imports: [
        LinkIdDirective,
        CommonModule,
        FontIconComponent,
    ]
})
export class FilterButtonComponent {

    @Input() id: string;
    @Input() ariaLabel;
    @Input() icon;
    @Input() selected = false;
    @Input() shrink = false;

    constructor() { }

}
